import React, { useEffect, useState } from 'react'
import { Button, Col, Modal, OverlayTrigger, Row, Table, Tooltip } from 'react-bootstrap'
import Price from '../options-forms/Price'
import { TbBasket } from 'react-icons/tb'

const AddToCart = (props) => {

   const { listData, basketState, formState, setCurrentStepIndex } = props
   const [showModal, setShowModal] = useState(false)

   const totalPrice = Object.values(basketState).reduce((previous, currrent) => {
      const currentCost = currrent.price?.value ? currrent.price.value : 0
      return previous + currentCost
   }, 0)

   const totalKiltPrice = Object.entries(basketState).filter(([key, value]) => {
      return key.startsWith('kiltTartan') || key.startsWith('pleat')
   })
      .reduce((previous, currrent) => {
         const currentCost = currrent[1].price?.value ? currrent[1].price.value : 0
         return previous + currentCost
      }, 0)

   useEffect(() => {
      const listDataLength = listData.length
      const validForms = listData.filter(form => form.isValid)
      setAllFormValid(listDataLength === validForms.length)
   }, [listData])

   const [allFormsValid, setAllFormValid] = useState(true)
   const [showOverlay, setShowOverlay] = useState(false)

   const handleToggle = () => {
      setShowOverlay(!showOverlay && !allFormsValid)
   }

   const toggleModal = () => {
      if (allFormsValid) {
         setShowModal(!showModal)
      }
   }

   const handleEditClick = (stepIndex) => {
      toggleModal()
      setCurrentStepIndex(stepIndex)
   }


   return (
      <>
         <OverlayTrigger
            show={showOverlay}
            onToggle={handleToggle}
            placement='bottom'
            overlay={
               <Tooltip id='add-tocart-trigger' >
                  Ensure all options are selected first
               </Tooltip>
            }
         >
            <Button
               onClick={toggleModal}
               variant='outline-dark'
               className={`rounded-0 px-3 ${allFormsValid ? '' : 'opacity-25'}`}
               size='sm'
            >
               <TbBasket size={18} />
            </Button>
         </OverlayTrigger>
         <Modal show={showModal} onHide={toggleModal}>


            <Modal.Body>
               <Modal.Header className='d-lg-none mb-4' closeButton>
                  <h4 >Your Configured Outfit</h4>
               </Modal.Header>
               <h4 className='d-none d-lg-block'>Your Configured Outfit</h4>
               <p>The Outfit builder is ready to be implmeneted into your site at this point. Either add the outfit to your shopping cart or email a request.</p>
               <Table striped bordered hover  >
                  <thead>
                     <tr>
                        <th>Item</th>
                        <th width='1%'>Price</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr>
                        <td>
                           <h6 className='mb-0'>
                              Kilt: {basketState?.kiltTartan?.title}
                              <span
                                 onClick={() => handleEditClick(0)}
                                 className='text-danger d-none d-lg-block  float-end small fw-normal' style={{ cursor: 'pointer' }}>edit</span>
                           </h6>
                           <ul className='list-unstyled small ps-3 my-0'>
                              <li>
                                 <span className='fw-bold'>
                                    Pleating
                                 </span>:
                                 {basketState?.pleatToTheStripe ?
                                    <> Pleat to the stripe <Price prefix='+' {...basketState?.pleatToTheStripe?.price} /></> :
                                    " Pleat to the sett"
                                 }
                              </li>
                           </ul>
                        </td>
                        <td><Price currency='GBP' value={totalKiltPrice} /></td>
                     </tr>
                     <tr>
                        <td>
                           <h6 className='mb-0'>
                              Straps: {basketState?.strap?.title}
                              <span
                                 onClick={() => handleEditClick(1)}
                                 className='text-danger d-none d-lg-block  float-end small fw-normal' style={{ cursor: 'pointer' }}>edit</span>
                           </h6>
                        </td>
                        <td><Price {...basketState?.strap?.price} /></td>
                     </tr>
                     <tr>
                        <td>
                           <h6 className='mb-0'>
                              Buckle: {basketState?.buckle?.title}
                              <span
                                 onClick={() => handleEditClick(2)}
                                 className='text-danger d-none d-lg-block  float-end small fw-normal' style={{ cursor: 'pointer' }}>edit</span>
                           </h6>
                        </td>
                        <td><Price {...basketState?.buckle?.price} /></td>
                     </tr>
                     <tr>
                        <td>
                           <h6 className='mb-0'>
                              Lining: {basketState?.lining?.title}
                              <span
                                 onClick={() => handleEditClick(3)}
                                 className='text-danger d-none d-lg-block  float-end small fw-normal' style={{ cursor: 'pointer' }}>edit</span>
                           </h6>
                        </td>
                        <td><Price {...basketState?.lining?.price} /></td>
                     </tr>
                     <tr>
                        <td>
                           <h6 className='mb-0'>
                              Measurements
                              <span
                                 onClick={() => handleEditClick(4)}
                                 className='text-danger d-none d-lg-block  float-end small fw-normal' style={{ cursor: 'pointer' }}>edit</span>
                           </h6>
                           <ul className='list-unstyled small ps-3 my-0'>
                              <li><span className='fw-bold'>Height:</span> <span >{formState?.height}</span></li>
                              <li><span className='fw-bold'>Waist: </span>{formState?.kiltWaist}</li>
                              <li><span className='fw-bold'>Hips: </span>{formState?.kiltHips}</li>
                              <li><span className='fw-bold'>Length:</span> {formState?.kiltLength}</li>
                           </ul>
                        </td>
                        <td></td>
                     </tr>

                     <tr>
                        <td className='text-end fw-bold'>Total</td>
                        <td><Price currency='GBP' value={totalPrice} /></td>
                     </tr>
                  </tbody>
               </Table>
               <Row>
                  <Col className='text-center'>
                     <form action="https://www.8yards.co.uk/highland-outfits-c10/test-c255/bespoke-kilt-test-p4155?page=1" method="post" id="js-add-to-basket__form">
                        <input type="hidden" name="parent_product_id" id="js-parent-product-id" value="4155" />
                        <input type="hidden" name="product_id" id="js-product-id" value="8006" /></form>



                  </Col>
               </Row>

            </Modal.Body>

         </Modal>
      </>
   )
}
export default AddToCart